/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  List, ListItem, ListItemText, Box, makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  listItem: {
    cursor: 'pointer',
    padding: 0,
    backgroundColor: 'none',
    '&:hover': {
      backgroundColor: 'none'
    }
  },
  selectedItem: {
    backgroundColor: 'none',
    '&:hover': {
      backgroundColor: 'none'
    }
  }
}));

const ReusableList = ({
  data, selectedItem, onSelect, children
}) => {
  const classes = useStyles();

  return (
    <Box>
      <List>
        {data.map((item, index) => (
          <ListItem
            key={index}
            button
            onClick={() => onSelect(item)}
            className={`${classes.listItem} ${selectedItem === item ? classes.selectedItem : ''}`}
          >
            {children ? children(item) : <ListItemText primary={item.label} />}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

ReusableList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItem: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.func
};

export default ReusableList;
